function observationRecencyMs(obs) {
  const candidates = [
    obs.created,
    obs.dispatched_at,
    obs.visible_at,
    obs.start_date,
  ];
  for (let index = 0; index < candidates.length; index += 1) {
    const ms = new Date(candidates[index]).getTime();
    if (Number.isFinite(ms)) return ms;
  }
  return Number(obs.id) || 0;
}

export function sortObservationsByRecency(list, newestFirst = true) {
  const sorted = [...(list || [])];
  sorted.sort((a, b) => {
    const recency = observationRecencyMs(b) - observationRecencyMs(a);
    if (recency !== 0) return newestFirst ? recency : -recency;
    const byId = Number(b.id) - Number(a.id);
    return newestFirst ? byId : -byId;
  });
  return sorted;
}
